var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-ui-accordion",style:({
    '--new-ui-accordion-duration': _vm._duration,
    '--new-ui-accordion-easing': _vm.easing
  }),attrs:{"data-accordion-status":_vm.status}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }